import './header.constructor.styles.scss'
export default function HeaderConstructorComponent({ title }: { title: string }) {

    return <div className='HeaderConstructorComponent'>
        <div className='title'>
            {title}
        </div>
    </div>

}